//* Libraries imports
import { Suspense } from "react";
import { motion } from "framer-motion";

//* Styles imports
import "./_components/essay-view.scss";

//* Components imports
import { Content } from "./_components/index";

export default function EssayView() {
  return (
    <motion.div 
      className="row"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.3 }}
    >
      <Suspense fallback={
        <motion.div 
          className="d-flex justify-content-center align-items-center py-5"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
        >
          <div className="spinner-border text-primary" role="status">
            <span className="visually-hidden">Carregando...</span>
          </div>
        </motion.div>
      }>
        <Content />
      </Suspense>
    </motion.div>
  );
}
